'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "start", "end"];
import * as React from 'react';
import { useRenderElement } from "../../base-ui-copy/utils/useRenderElement.mjs";
import { CompositeList } from "../../base-ui-copy/composite/list/CompositeList.mjs";
import { CalendarGridDayRowContext } from "./CalendarGridDayRowContext.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export const CalendarGridDayRow = /*#__PURE__*/React.forwardRef(function CalendarGridDayRow(componentProps, forwardedRef) {
  const {
      // Rendering props

      // Internal props
      start,
      end
      // Props forwarded to the DOM element
    } = componentProps,
    elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);
  const props = {
    role: 'row'
  };
  const cellsRefs = React.useRef([]);
  const contextValue = React.useMemo(() => ({
    start,
    end
  }), [start, end]);
  const element = useRenderElement('div', componentProps, {
    ref: [forwardedRef],
    props: [props, elementProps]
  });
  return /*#__PURE__*/_jsx(CompositeList, {
    elementsRef: cellsRefs,
    children: /*#__PURE__*/_jsx(CalendarGridDayRowContext.Provider, {
      value: contextValue,
      children: element
    })
  });
});
if (process.env.NODE_ENV !== "production") CalendarGridDayRow.displayName = "CalendarGridDayRow";